String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
}
let delay = (function(){
    var timer = 0;
    return function(callback, ms){
        clearTimeout (timer);
        timer = setTimeout(callback, ms);
    };
})();
